export class Url {

    public SgunBase: string;
    public SgunService: string;
    public SgunReferer: string;
    public SgunWebServiceHost: string;
    public SgunAuthorization: string;
    public Cientifico: string;
    public Sogesp: string;

}









// WEBPACK FOOTER //
// ./src/models/url.model.ts